
function dispenseUplift() {
  const buttonDispense = $('.uplift-dispense-button');
  buttonDispense.on('click', dispense);
}

function dispense(e) {
  e.preventDefault();
  const id = $(e.target).data('id');

  $.ajax({
    url: '/uplift/' + id + '/dispense',
    method: 'POST',
    success: function(response) {
      location.reload();
    },
    error: function(xhr) {
      console.error('Erro ao dispensar uplift:', xhr);
    }
  });
}

module.exports = {
  init: dispenseUplift,
};
